import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { formatDateID, waLink } from "@/lib/constants";

// Saran jadwal terdekat (maks 3 dalam 14 hari) saat tanggal/petugas terpilih kosong.
export const NearestSlots = ({ serviceId, date, petugas, lokasi, candidates, clinicWa, onPick }) => {
  const [res, setRes] = useState(null);
  const key = candidates.join(",");
  useEffect(() => {
    if (!serviceId || !date || !key) { setRes(null); return; }
    let ignore = false;
    setRes("loading");
    axios.get(`${API}/public/nearest-slots`, { params: { service_id: serviceId, date, petugas, lokasi, candidates: key } })
      .then((r) => { if (!ignore) setRes(r.data.suggestions || []); })
      .catch(() => { if (!ignore) setRes([]); });
    return () => { ignore = true; };
  }, [serviceId, date, petugas, lokasi, key]);
  if (res === null) return null;
  if (res === "loading") return <p className="mt-2 text-xs text-slate-400">Mencari jadwal terdekat...</p>;
  if (res.length === 0) return (
    <div data-testid="pb-nearest-empty" className="mt-2 rounded-xl border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800">
      Jadwal sedang penuh, silakan hubungi admin.
      {clinicWa && <a data-testid="pb-nearest-wa" href={waLink(clinicWa, "Halo Admin GBS, saya ingin bertanya jadwal yang tersedia.")} target="_blank" rel="noreferrer" className="ml-2 inline-block rounded-lg bg-emerald-600 px-3 py-1.5 font-bold text-white">WhatsApp Admin</a>}
    </div>
  );
  return (
    <div data-testid="pb-nearest" className="mt-2 rounded-xl border border-[#FBCFE8] bg-[#FDF2F8] p-3">
      <p className="text-xs font-bold text-[#DB2777]">Jadwal terdekat yang tersedia</p>
      <div className="mt-2 flex flex-col gap-1.5">
        {res.map((s, i) => (
          <button key={`${s.tanggal}-${s.petugas_nama}`} type="button" data-testid={`pb-nearest-${i}`} onClick={() => onPick(s)} className="flex flex-wrap items-center justify-between gap-1 rounded-lg border border-white bg-white px-3 py-2 text-left text-xs transition-colors hover:border-[#EC4899]">
            <span className="font-semibold text-slate-700">{formatDateID(s.tanggal)} · {s.jam}</span>
            <span className="text-slate-500">{s.petugas_nama}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
